module.exports = __webpack_public_path__ + "img/tablet.1cb7b342.jpg";